module.exports = "/images/veil-6.jpg";